import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const MarketplaceAuthContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL;

export function MarketplaceAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('marketplace_token'));
  const [loading, setLoading] = useState(true);

  const fetchProfile = useCallback(async (t) => {
    try {
      const res = await axios.get(`${API_URL}/api/marketplace/auth/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      setUser(res.data);
    } catch {
      localStorage.removeItem('marketplace_token');
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (token) {
      fetchProfile(token);
    } else {
      setLoading(false);
    }
  }, [token, fetchProfile]);

  const login = async (email, password) => {
    const res = await axios.post(`${API_URL}/api/marketplace/auth/login`, { email, password });
    const { access_token, user: userData } = res.data;
    localStorage.setItem('marketplace_token', access_token);
    setToken(access_token);
    setUser(userData);
    return userData;
  };

  const register = async (data) => {
    const res = await axios.post(`${API_URL}/api/marketplace/auth/register`, data);
    const { access_token, user: userData } = res.data;
    localStorage.setItem('marketplace_token', access_token);
    setToken(access_token);
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('marketplace_token');
    setToken(null);
    setUser(null);
  };

  return (
    <MarketplaceAuthContext.Provider value={{ user, token, loading, login, register, logout }}>
      {children}
    </MarketplaceAuthContext.Provider>
  );
}

export function useMarketplaceAuth() {
  const ctx = useContext(MarketplaceAuthContext);
  if (!ctx) throw new Error('useMarketplaceAuth must be used within MarketplaceAuthProvider');
  return ctx;
}
